export function ColorField(name = '', label = '', value = '') {
  this.name = name;
  this.label = label;
  this.value = value;
}
